<script>
/**
 * マスタ管理 メニュー一覧画面
 *  並び順の変更処理
 *  登録内容の変更、新しいメニューの追加画面へ遷移
 */
</script>
<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="get_list_data"
            class="golfGroupTbody"
            hide-default-footer
            disable-pagination
            :height="700"
        >
            <template v-slot:[`item.child_name`]="{ item }">
                <label v-if="item.show_check === false && item.child_name == null" class="redselect">リンクの登録と子画面の登録がないためメニューに表示されません</label>
                <label v-else>{{ item.child_name }}</label>
            </template>
            <template v-slot:[`item.valid_flag`]="{ item }">
                <v-checkbox v-model="item.valid_flag" disabled class="pl-12" />
            </template>
            <template v-slot:[`item.futter_flag`]="{ item }">
                <v-checkbox v-model="item.futter_flag" disabled class="pl-12" />
            </template>
            <template v-slot:[`item.btn_up`]="{ item }">
                <v-btn
                    :disabled="btn[1].isActive || item.sort_no == 1"
                    color="primary"
                    @click="changePiority(item, -1)">△</v-btn>
            </template>
            <template v-slot:[`item.btn_down`]="{ item }">
                <v-btn
                    :disabled="btn[1].isActive || item.sort_no == dataCount"
                    color="primary"
                    @click="changePiority(item, 1)">▽</v-btn>
            </template>
            <template v-slot:[`item.Btn`]="{ item }">
                <v-btn
                    color="green darken-4"
                    text
                    @click="editModal(item)"
                    :disabled="btn[3].isActive || item.btnDisabled"
                    v-if="item.template !== null"
                    class="editBtn">変更</v-btn>
            </template>
        </v-data-table>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                :disabled="btn[1].isActive"
                color="green darken-4"
                text
                @click="comfirmUpdate">表示順登録</v-btn>
            <v-btn
                :disabled="btn[1].isActive"
                color="green darken-4"
                text
                @click="addModalView">追加</v-btn>
        </v-card-actions>

        <v-overlay :value="data_update">
            <v-card light width="500px">
                <v-card-title>表示順登録の最終確認</v-card-title>
                <v-card-text>表示順を変更します。</v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="data_update = !data_update">キャンセル</v-btn>
                    <v-btn color="primary" text @click="updateData(get_list_data)">登録する</v-btn>
                </v-card-actions>
            </v-card>
        </v-overlay>

        <v-overlay :value="data_update_return">
            <v-card light width="500px">
                <v-card-title >表示順登録</v-card-title>
                <v-card-text>{{ result_text }}</v-card-text>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="data_update_return = !data_update_return">閉じる</v-btn>
                </v-card-actions>
            </v-card>
        </v-overlay>

        <MenuModal
            ref="Modal"
            :edit-info="find_data"
            @refresh-event="getList"
        ></MenuModal>
    </div>
</template>
<script>

// mixins
import { MasterPagesMixin } from './mixin/MasterPagesMixin.js';
import { authorityMixin } from '@/views/authorityMixin';

// graghql
import { GET_MENU_MASTER_LIST , UPDATE_MENU_MASTER} from '@/constants/menu_master';

// モーダル
import MenuModal from './modal/MenuModal';

export default {
    components: {
        MenuModal
    },
    // マスタ管理の共通項目をMixinする ./mixin/MasterPagesMixin.js
    mixins: [
        authorityMixin,
        MasterPagesMixin
    ],
    data () {
        return {
            // v-data-tableのヘッダー
            headers: [
                { text: '表示順',       value: 'sort_no',          sortable: false, align: 'center' },
                { text: '親タイトル',   value: 'parent_name',      sortable: false },
                { text: '子タイトル',   value: 'child_name',       sortable: false },
                { text: 'サイドメニューに表示する', value: 'valid_flag', sortable: false },
                { text: 'メニューに表示する', value: 'futter_flag', sortable: false},
                { text: '表示順上げる', value: 'btn_up',           sortable: false },
                { text: '表示順下げる', value: 'btn_down',         sortable: false },
                { text: '',            value: 'Btn',              sortable: false }
            ],
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '参照', isActive: true },
                { element_id: '002', element_name: '追加', isActive: true },
                { element_id: '003', element_name: '変更', isActive: true },
                { element_id: '004', element_name: '削除', isActive: true }
            ],
            // ソート番号桁数
            sort_digit: 2,
            // 並び順変更ポップアップ表示フラグ
            data_update: false,
            data_update_return: false,
            result_text: '',
            // 一覧格納
            get_list_data: [],
            // 更新画面用
            find_data:[],
            // 共通関数（マスタ画面ID）
            vue_id: 'SCR0010',
            // メニューID
            menu_id_cardsetting: '6',
            menu_id_chatbox: '10',
            menu_id_linesetting: '11',
            // フッターのメニュー数
            menuCount: 0,
        };
    },
    created () {
        this.Initialize();
    },
    methods: {
        async Initialize () {
            // ログインしているユーザーを取得
            this.admin = await this.getLoginAdmin();
            // 権限取得
            this.getAuthorityList();

            // 一覧のデータを取得
            await this.getData();
        },
        /** ----------------------------------------------
         * 一覧取得処理
         * ---------------------------------------------- */
        async getData () {
            try {
                this.$apollo.query({
                    query: GET_MENU_MASTER_LIST
                }).then(res => {
                    this.get_list_data = res.data.GetMenuMaster.MenuMasterLists;
                    let chatboxSetting = res.data.GetMenuMaster.ChatboxSetting;
                    let lineSetting = res.data.GetMenuMaster.LineSetting;
                    let cardSetting = res.data.GetMenuMaster.CardSetting;
                    this.menuCount = res.data.GetMenuMaster.MenuCount;

                    for (var i = 0; i < this.get_list_data.length; i++) {
                        var item = this.get_list_data[i];

                        // ソートで並び変える
                        item.sort_no = this.numberSliceSettings(i + 1, this.sort_digit);

                        // 会員画面表示有効チェック
                        item.show_check = true;
                        // 外部リンク無効 かつ 内部リンクNULL かつ 子画面なし の場合、アラート表示
                        if(item.external_link == 0 && item.url == null && item.childhas == false){
                            item.show_check = false;
                        }

                        // システム設定で停止されている機能は変更不可にする
                        if (
                            (item.menu_id === this.menu_id_chatbox && chatboxSetting === 0) ||
                            (item.menu_id === this.menu_id_linesetting && lineSetting === 0) ||
                            (item.menu_id === this.menu_id_cardsetting && cardSetting === 0)
                        ) {
                            item.btnDisabled = true;
                        } else {
                            item.btnDisabled = false;
                        }

                        // 格納
                        this.get_list_data[i] = item;
                    }
                    this.dataCount = this.numberSliceSettings(this.get_list_data.length, this.sort_digit);
                }).catch(error => { this.error = error; });

                this.$store.commit('loading/setIsLoading', false);
            } catch (error) {
                this.result_text = error;
                this.$store.commit('loading/setIsLoading', false);
            }
        },
        /** ----------------------------------------------
         * 表示順登録処理
         * ---------------------------------------------- */
        updateData(lists) {
            try {
                // ローディング
                this.$store.commit('loading/setIsLoading', true);

                let data = [];
                let obj = {};
                for (let list of lists) {
                    obj = {
                        menu_id: Number(list.menu_id),
                        sort_no: list.sort_no
                    };
                    data.push(obj);
                }
                this.$apollo.mutate({
                    mutation: UPDATE_MENU_MASTER,
                    variables: {
                        UpdateMenuMaster: data,
                        SortFlg: true
                    }
                }).then(res => {
                    var result = Number(res.data.UpdateMenuMaster.result);
                    if (result === 1) {
                        this.result_text = '登録が終了しました。';
                    } else {
                        this.result_text = 'エラーが発生しました。';
                    }
                    // ローディングオフ
                    this.$store.commit('loading/setIsLoading', false);
                });
            } catch (error) {
                this.result_text = error;

                // ローディングオフ
                this.$store.commit('loading/setIsLoading', false);
            }

            // ポップアップの表示切り替え
            this.data_update = false;
            this.data_update_return = true;
        },
        /** ----------------------------------------------
         * 表示順登録ポップアップ表示
         * ---------------------------------------------- */
        comfirmUpdate () {
            this.result_text = '';
            this.data_update = true;
        },
        /** ----------------------------------------------
         * ソートNoの変更
         *
         * 会員画面で表示されるメニューは、
         * 親メニューのソート後、子メニューのソートで表示される
         * そのため、この画面で親よりも上に子のメニューが表示されていたとしても
         * 会員画面で親メニューより上に子のメニューは表示されない
         * また、子メニューの間に別の親メニューが表示されている場合も同様に
         * 会員画面で子のメニューの間に別の親メニューは表示されない
         * ---------------------------------------------- */
        changePiority (item, num) {
            let new_get_list_data = [];
            // ボタンを押下した行の変更したいソートNO
            let newNum = Number(item.sort_no) + num;

            // 行の数だけ繰り返し
            for (let i = 0; i < this.get_list_data.length; i++) {
                // 現在の行番号
                let itemNum = Number(this.get_list_data[i]['sort_no']);

                // 変更したいソートNOと同じソートNOを持つ行の場合
                if (itemNum === newNum) {
                    // ソートNOを変更する
                    this.get_list_data[i]['sort_no'] = this.numberSliceSettings((newNum - num), this.sort_digit);
                    new_get_list_data[(newNum - num - 1)] = this.get_list_data[i];
                } else if (itemNum === Number(item.sort_no)) {
                    // 変更前のソートNOを変更後のソートNOに変更する
                    this.get_list_data[i]['sort_no'] = this.numberSliceSettings(newNum, this.sort_digit);
                    new_get_list_data[(newNum - 1)] = this.get_list_data[i];
                } else {
                    new_get_list_data[i] = this.get_list_data[i];
                }
            }
            // 一時配列を表示用の配列に上書きする
            this.get_list_data = [];
            this.get_list_data = new_get_list_data;
            this.dataCount = this.get_list_data.length;
        },
        /** ----------------------------------------------
        * 追加ボタン押下時の処理
        * 子コンポーネントのmodalをtrueにして表示する
        * ---------------------------------------------- */
        addModalView () {
            this.find_data['menuCount'] = this.menuCount;
            this.$refs.Modal.addModal();
        },
        /** --------------------------------------------
        * 変更ボタン押下時の処理
        * 子コンポーネントのmodalをtrueにして表示する
        * -------------------------------------------- */
        editModal (item) {
            this.find_data = this.get_list_data.find(ele => ele.menu_id === item.menu_id);
            this.find_data['menuCount'] = this.menuCount;
            this.$refs.Modal.editModal();
        },
        getList(){
            // 一覧のデータを取得
            this.getData();
        }
    }
};
</script>
